import React from 'react';
import { GitBranch } from 'lucide-react';

const BusinessFlowWizard = ({ data, setData }) => {
  return (
    <div className="animate-in fade-in slide-in-from-top-4 duration-500 text-left space-y-6">

      {/* NOTA DEL ARQUITECTO */}
      <div className="bg-blue-900/10 border-l-4 border-blue-600 p-5 rounded-r-3xl flex gap-4 items-start">
        <div className="bg-blue-600 p-2 rounded-xl text-white shrink-0">
          <GitBranch size={18} />
        </div>
        <div>
          <p className="text-[11px] text-blue-400 font-black uppercase tracking-widest mb-1">
            Business Flow Guide
          </p>
          <p className="text-[11px] text-slate-400 leading-relaxed">
            Esta herramienta convierte requerimientos de negocio en diagramas de flujo técnicos 
            usando <strong>Mermaid.js</strong>. Ingresá el nombre del proceso y seleccioná el tipo 
            de flujo. El motor genera la secuencia lógica completa con decisiones, excepciones 
            y módulos SAP involucrados.
          </p>
        </div>
      </div>

      {/* WIZARD */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">

        {/* IZQUIERDA */}
        <div className="bg-[#0F172A] p-6 rounded-[28px] text-white border-b-4 border-blue-500 space-y-4">
          <label className="text-[10px] font-black text-blue-400 uppercase flex items-center gap-2 border-b border-slate-800 pb-2">
            <GitBranch size={14} /> Configuración del Flujo
          </label>

          <div>
            <label className="text-[9px] font-bold text-slate-400 uppercase block mb-1">
              Nombre del Proceso
            </label>
            <input
              type="text"
              className="w-full p-2.5 bg-slate-800 border border-slate-700 rounded-xl text-xs text-white placeholder:text-slate-600 outline-none focus:border-blue-400"
              placeholder="Ej: Validación de Crédito en Pedidos"
              value={data.flowName || ''}
              onChange={(e) => setData({ ...data, flowName: e.target.value })}
            />
          </div>

          <div>
            <label className="text-[9px] font-bold text-slate-400 uppercase block mb-1">
              Tipo de Flujo
            </label>
            <select
              className="w-full p-2.5 bg-slate-800 border-none rounded-xl text-xs font-bold text-white outline-none focus:ring-2 focus:ring-blue-500"
              value={data.flowType || 'Custom'}
              onChange={(e) => setData({ ...data, flowType: e.target.value })}
            >
              <option value="Custom">Proceso Z (Nuevo)</option>
              <option value="Standard">Extensión Estándar (User Exit/BAdI)</option>
              <option value="Interface">Interface (API/IDoc)</option>
              <option value="Workflow">SAP Workflow</option>
              <option value="Integration">Integración entre sistemas</option>
            </select>
          </div>

          <div>
            <label className="text-[9px] font-bold text-slate-400 uppercase block mb-1">
              Módulo SAP Principal
            </label>
            <select
              className="w-full p-2.5 bg-slate-800 border-none rounded-xl text-xs font-bold text-white outline-none focus:ring-2 focus:ring-blue-500"
              value={data.flowModule || 'MM'}
              onChange={(e) => setData({ ...data, flowModule: e.target.value })}
            >
              <option value="MM">MM — Gestión de Materiales</option>
              <option value="SD">SD — Ventas y Distribución</option>
              <option value="FI">FI — Finanzas</option>
              <option value="CO">CO — Controlling</option>
              <option value="PP">PP — Planificación de Producción</option>
              <option value="HR">HR — Recursos Humanos</option>
              <option value="PM">PM — Mantenimiento de Planta</option>
              <option value="WM">WM — Gestión de Almacenes</option>
              <option value="BTP">BTP — SAP Business Technology Platform</option>
            </select>
          </div>
        </div>

        {/* DERECHA */}
        <div className="bg-[#0F172A] p-6 rounded-[28px] text-white border-b-4 border-blue-500 space-y-4">
          <label className="text-[10px] font-black text-blue-400 uppercase flex items-center gap-2 border-b border-slate-800 pb-2">
            <GitBranch size={14} /> Opciones de Salida
          </label>

          <div className="grid grid-cols-2 gap-3">
            {[
              { key: "includeErrors",    label: "Include Errors",     desc: "Manejo de excepciones" },
              { key: "includePseudoCode", label: "Pseudo Code",       desc: "Lógica en pseudocódigo" },
              { key: "diagramType",      label: "Diagram Type",       desc: "Tipo de diagrama Mermaid" },
              { key: "modularization",   label: "Modularization",     desc: "Separar en módulos" },
              { key: "includeTablas",    label: "Include Tablas SAP", desc: "Tablas involucradas" },
              { key: "includeBapis",     label: "Include BAPIs",      desc: "BAPIs y FMs sugeridos" },
            ].map((opt) => (
              <button
                key={opt.key}
                onClick={() => setData({
                  ...data,
                  flowOptions: {
                    ...data.flowOptions,
                    [opt.key]: !data.flowOptions?.[opt.key]
                  }
                })}
                className={`p-3 text-left rounded-xl border transition-all ${
                  data.flowOptions?.[opt.key]
                    ? 'bg-blue-600/20 border-blue-500/50 text-blue-400'
                    : 'bg-slate-800 border-slate-700 text-slate-500 hover:border-slate-600'
                }`}
              >
                <p className="text-[10px] font-black uppercase">{opt.label}</p>
                <p className="text-[9px] text-slate-500 mt-0.5">{opt.desc}</p>
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BusinessFlowWizard;